import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'

export const organisations = {
    searchOrganisations,
    getPartcipatedShops,
    signUpOrganisation,
    signOutOrganisation,
    switchOrganisation
}

async function searchOrganisations({
    page = 1,
    size = 20,
    name,
    relationship,
    service_registry,
    industries,
    nearby_latlon,
    industry_sector,
    town_cities,
    organisations,
    sort='name',//='UPDATED_DATE',
    order='ASC', //='DESC'
    distance,
    lat,
    lon,
    contact_registry = true,
    ignore_contat_registry = false,
    organisation_tag,
} = {}, orgId) {
    try {
        let queryParams = {
            page,
            size,
            name,
            relationship,
            service_registry,
            industries,
            nearby_latlon,
            industry_sector,
            town_cities,
            organisations,
            sort,//='UPDATED_DATE',
            order, //='DESC'
            distance,
            lat,
            lon,
            organisation_tags: organisation_tag,
        };
        if(!ignore_contat_registry){
            queryParams.contact_registry = contact_registry;
        }
        let id = httpUtil.getSession().current_organisation_id;
        let response = await httpUtil.get({
            resourcePath: '/v1/organisations/' + id + '/network',
            queryParams: queryParams,
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getMerchants: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPartcipatedShops({
    page = 1,
    size = 20,
    name,
    sort,
    order,
    include_wallet = false,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: '/v1/contacts/' + id + '/organisations',
            queryParams: {
                page,
                size,
                name,
                sort,
                order,
                include_wallet
            }, withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getMerchants: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function signUpOrganisation({
    organisation_id,
    email_opt_out,
    sms_opt_out,
    referral_code,
    action='SIGNUP',
}) {
    console.log("organisation_id:",organisation_id);
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: '/v1/contacts/' + id + '/organisations',
            body: {
                action,
                referral_code,
                organisation_id,
                email_opt_out,
                sms_opt_out
            },
            withAccessToken: true
        });
        if (response.code == "OK") {
            return await switchOrganisation(organisation_id,true);          
        }else{
            if( response.error && response.error.error ==='COM.CRM.EXCEPTIONS.SIGNUPOFFORGANISATIONISNOTALLOWEDEXCEPTION'){
                return createResult(ErrorCodes.SIGN_UP_ORGANISATION_ALREADY, response);
            }else{
                return createCommonResult(response);
            }
        }
        //check return code here instead of put as there would be different intepretation for different API
    } catch (e) {
        console.log('Exception signUpOrganisation: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function signOutOrganisation({
    organisation_id,
    action='SIGNOFF',
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: '/v1/contacts/' + id + '/organisations',
            body: {
                action,
                organisation_id,
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception signOutOrganisation: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function switchOrganisation(organisation_id,isMerchant) {
    try {
        let response = await httpUtil.post({
            resourcePath: '/v1/organisations/' + organisation_id + '/switch',
            body: {},
            withAccessToken: true
        });
        if (response.code == "OK") {
            httpUtil.switchSession(response.data,isMerchant);
        }
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception switchOrganisation: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}